// vue
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';
import { NewGeoCoords } from '../models';

export const useDuplicateSerice = () => {
    // properties
    const { apiUrl } = useStore().state;
    const axios = useAxios();

    // methods
    const useDuplicateRecord = async (newData: NewGeoCoords): Promise<any> => {
        const res = await axios.post(
            `${apiUrl}/v2/geo-record-duplicate`,
            newData,
        );
        return res.data;
    };
    return {
        useDuplicateRecord,
    };
};
